import React from 'react'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { LogoDark } from '../../../assets/icons'
import BackButtonMobile from '../BackButtonMobile'
import { Image, Linking, TouchableOpacity } from 'react-native'
import { useResponsive } from '../../../utils/hooks'
import RootStore from '../../../store'
import { urls } from '@linqpal/models/src/dictionaries'

interface LogoContainerProps {
  showsBackButton?: boolean
  onBackPress?: () => void
}

export const LogoContainer: React.FC<LogoContainerProps> = ({
  showsBackButton,
  onBackPress,
}) => {
  const { sm } = useResponsive()
  const { branding } = RootStore
  return (
    <TouchableOpacity
      onPress={() => !branding && Linking.openURL(urls.BT)}
      style={composeStyle(
        {
          alignItems: 'center',
          paddingVertical: 23,
        },
        !sm
          ? {
              width: '100%',
              alignItems: 'center',
              paddingVertical: 20,
              borderBottomWidth: 1,
              borderColor: '#E6EBEE',
            }
          : {},
      )}
    >
      {/* showing BackButton inside header on mobile */}
      {!sm && showsBackButton ? (
        <BackButtonMobile onBackPress={onBackPress} />
      ) : null}
      {branding ? (
        <Image
          source={{ uri: branding?.logoUrl }}
          style={{ width: 468, height: 164 }}
          resizeMode="contain"
        />
      ) : (
        <LogoDark width={sm ? 163 : 122} height={sm ? 20 : 16} />
      )}
    </TouchableOpacity>
  )
}
